export const API = '/mkapi/v1'

// Common API parameters
export const KEY_PARAM = '?key='

// Config API endpoints
export const API_CONFIG = `${API}/config`
export const API_CONFIG_BY_GROUP = `${API_CONFIG}/configsByGroupKey`
export const API_CONFIG_GROUPS = `${API_CONFIG}/groups`
export const API_CONFIGS_BY_GROUPS = `${API_CONFIG}/configsByGroups`
export const API_PAGE_CONFIG = `${API}/meta`

// ConfigV2 API endpoints
export const API_CONFIGV2 = `${API}/configV2`
export const API_CONFIGV2_KEY = API_CONFIGV2 + KEY_PARAM
// API Headers
export const NM_CONTENT_TYPE = 'Content-Type'
export const CONTENT_APPLICATION_JSON = 'application/json'
export const X_BRANDID = 'X-BRANDID'
export const X_JWT_TOKEN = 'X-JWT-TOKEN'
export const X_JWT_MEMBER_TOKEN = 'X-JWT-MEMBER-TOKEN'
export const ACCESS_CODE = 'access-code'

// API Error messages
export const ERROR_HTTP = 'HTTP error! status'
export const ERROR_NO_DATA = 'No data received'

// API endpoints (serverUrl-based)
export const API_SERVER_CONTENT = (serverUrl: string) => `${serverUrl}${API}/content`
export const API_SERVER_CONFIG = (serverUrl: string) => `${serverUrl}${API}/config`
export const API_SERVER_CONFIG_BY_GROUP = (serverUrl: string) => `${serverUrl}${API}/config/configsByGroupKey`
export const API_SERVER_CONFIG_GROUPS = (serverUrl: string) => `${serverUrl}${API}/config/groups`
export const API_SERVER_CONFIGS_BY_GROUPS = (serverUrl: string) => `${serverUrl}${API}/config/configsByGroups`
export const API_SERVER_CONFIGV2 = (serverUrl: string) => `${serverUrl}${API}/configV2`
export const API_SERVER_CONFIGV2_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/configV2?key=`
export const API_SERVER_COMP = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp`
export const API_SERVER_COMP_BEAN = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp/compBean`
export const API_SERVER_COMP_BEAN_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp/compBean/key`
export const API_SERVER_COMP_LIST = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp/compList`
export const API_SERVER_FEATURED_COMP_LIST = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp/featuredCompList`
export const API_SERVER_PREV_COMP_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp/prevComp/key`
export const API_SERVER_NEXT_COMP_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/comp/nextComp/key`
export const API_SERVER_DEMO_RESORT = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort`
export const API_SERVER_DEMO_RESORT_BEAN = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort/demoResortBean`
export const API_SERVER_DEMO_RESORT_BEAN_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort/demoResortBean/key`
export const API_SERVER_DEMO_RESORT_LIST = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort/demoResortList`
export const API_SERVER_FEATURED_DEMO_RESORT_LIST = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort/featuredDemoResortList`
export const API_SERVER_PREV_DEMO_RESORT_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort/prevDemoResort/key`
export const API_SERVER_NEXT_DEMO_RESORT_KEY = (serverUrl: string) => `${serverUrl}/mkapi/v1/demoResort/nextDemoResort/key`
export const API_SERVER_SEARCH = (serverUrl: string) => `${serverUrl}/mkapi/v1/search`
export const API_SERVER_REGION_LIST = (serverUrl: string) => `${serverUrl}/mkapi/v1/search/regionList`
export const API_SERVER_EXPLORE_RESULTS = (serverUrl: string) => `${serverUrl}/mkapi/v1/search/exploreResults`
export const API_SERVER_LOCATION_MAP = (serverUrl: string) => `${serverUrl}/mkapi/v1/search/locationMap`
export const API_SERVER_DUES_LOANS = (serverUrl: string) => `${serverUrl}/mkapi/v1/duesLoans`
export const API_SERVER_DASHBOARD = (serverUrl: string) => `${serverUrl}/mkapi/v1/dashboard`
export const API_SERVER_UPCOMING_VACATIONS = (serverUrl: string) => `${serverUrl}/mkapi/v1/vacations/upcoming`
export const API_SERVER_PAGE_META = (serverUrl: string) => `${serverUrl}${API}/meta`

export const MK_API_CONSTANTS = {
  RESORT_ENDPOINT: '/mkapi/v1/resorts',
  AVAILABILITY_ENDPOINT: '/mkapi/v1/availability',
  SEARCH_ENDPOINT: '/mkapi/v1/search',
  BOOKING_ENDPOINT: '/mkapi/v1/booking',
  ACCOUNT_ENDPOINT: '/mkapi/v1/account',
  WISHLIST_ENDPOINT: '/mkapi/v1/wishlist',
}

export const API_AEM_XF_PROXY = `${API}/aem-xf-proxy`

/* === Error messages === */
export const GENERIC_ERROR_MESSAGE = 'There has been a server error'
